// Shared sidebar navigation styles

export const NAV = {
  mx: 1.25,
  radius: 2.5,
  itemHeight: 44,
  iconSize: 36,
  activeGradient: 'linear-gradient(135deg, #3a9468 0%, #1f5b40 100%)',
  activeSoft: 'rgba(31, 91, 64, 0.1)',
  hover: 'rgba(31, 91, 64, 0.06)',
  iconBg: 'rgba(31, 91, 64, 0.08)',
  iconBgActive: 'rgba(255, 255, 255, 0.2)',
  submenuBorder: 'rgba(31, 91, 64, 0.12)'
};

export function getNavIconBoxSx(isActive, isSubItem = false) {
  return {
    width: isSubItem ? 28 : NAV.iconSize,
    height: isSubItem ? 28 : NAV.iconSize,
    minWidth: isSubItem ? 28 : NAV.iconSize,
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    transition: 'all 0.2s ease',
    bgcolor: isActive ? 'rgba(31, 91, 64, 0.14)' : NAV.iconBg,
    color: isActive ? 'primary.main' : 'text.secondary'
  };
}

export function getNavItemSx({ isActive, isSubItem, drawerOpen }) {
  if (!drawerOpen) {
    return {
      justifyContent: 'center',
      borderRadius: NAV.radius,
      minHeight: NAV.itemHeight,
      '&:hover': { bgcolor: 'transparent' },
      '&.Mui-selected': { bgcolor: 'transparent' }
    };
  }

  if (isSubItem) {
    return {
      zIndex: 1201,
      borderRadius: 2,
      mx: 0,
      mb: 0.35,
      py: 0.85,
      px: 1.5,
      minHeight: 38,
      transition: 'all 0.2s ease',
      bgcolor: isActive ? NAV.activeSoft : 'transparent',
      color: isActive ? 'primary.main' : 'text.primary',
      '&:hover': { bgcolor: isActive ? 'rgba(31, 91, 64, 0.14)' : NAV.hover },
      '&.Mui-selected': {
        bgcolor: NAV.activeSoft,
        color: 'primary.main',
        '&:hover': { bgcolor: 'rgba(31, 91, 64, 0.14)' }
      }
    };
  }

  return {
    zIndex: 1201,
    borderRadius: NAV.radius,
    mx: NAV.mx,
    mb: 0.5,
    py: 0.75,
    px: 1,
    minHeight: NAV.itemHeight,
    transition: 'all 0.2s ease',
    bgcolor: isActive ? NAV.activeSoft : 'transparent',
    color: isActive ? 'primary.main' : 'text.primary',
    boxShadow: 'none',
    '&:hover': {
      bgcolor: isActive ? 'rgba(31, 91, 64, 0.14)' : NAV.hover
    },
    '&.Mui-selected': {
      bgcolor: NAV.activeSoft,
      color: 'primary.main',
      '& .MuiListItemIcon-root': { color: 'primary.main' },
      '&:hover': { bgcolor: 'rgba(31, 91, 64, 0.14)' }
    }
  };
}
